var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMesile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 77,
    viewBox: "0 0 54 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8722 0L20.9336 9.9386L24.0721 16.0411L5.93848 28.9437C9.42539 30.9487 13.0876 33.8257 16.5745 37.2257C20.0614 40.7126 22.8515 44.2872 24.8565 47.8617L37.7591 29.7282L43.8616 32.8667L53.8002 22.9281L38.6306 15.0821L30.8722 0Z",
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1338 39.7542C10.7338 36.3542 7.07235 33.4772 3.6723 31.6467C3.49776 31.5598 3.4108 31.4722 3.32384 31.3853C-1.12222 36.7033 -0.948172 44.7239 4.10833 49.7804C9.16482 54.8369 17.1854 55.0115 22.5035 50.5649C22.4165 50.4779 22.3289 50.3034 22.242 50.2164C20.324 46.8157 17.4469 43.1543 14.1338 39.7543L14.1338 39.7542Z",
    fill: "#5A5A5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6788 49.3438L34.7092 54.3134L36.2781 57.365L27.9961 63.293C29.7396 64.339 31.483 65.734 33.1396 67.3905C34.7962 69.0471 36.1912 70.7905 37.2371 72.534L43.1651 64.252L46.2167 65.8209L51.1863 60.8513L43.6018 56.9283L39.6788 49.3438Z",
    fill: "#5A5A5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6977 69.8319C29.0411 68.1753 27.2976 66.7802 25.6412 65.9089C25.5542 65.8219 25.4667 65.8219 25.3797 65.7344C23.7231 68.35 23.9847 71.9245 26.3387 74.1909C28.6928 76.5449 32.1798 76.8065 34.8823 75.063C34.7953 74.976 34.7077 74.8884 34.7077 74.8015C33.6624 73.2319 32.2673 71.4014 30.6977 69.8319L30.6977 69.8319Z",
    fill: "#5A5A5A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesile);
export default __webpack_public_path__ + "static/media/mesile.e0e9e49c4da0acc2e0a1e80f5cc92089.svg";
export { ForwardRef as ReactComponent };